import React, { ChangeEvent, useRef } from 'react';

import AttachFileIcon from '@mui/icons-material/AttachFile';

import theme from '../../../../styles/theme';
import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

interface IAttachFilesActionButtonProps
  extends Pick<IBaseActionButtonProps, 'disabled'> {
  onFileInput?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const AttachFilesActionButton = (props: IAttachFilesActionButtonProps) => {
  const { classes } = useStyles();
  const fileUploadButtonRef = useRef<HTMLInputElement | null>(null);
  const { onFileInput } = props;

  return (
    <>
      <BaseActionButton
        styles={{
          width: theme.spacing(3.5),
          height: theme.spacing(3.5),
          color: theme.palette.grey[500],
          '&:hover': {
            color: theme.palette.primary.main,
          },
        }}
        onClick={() => fileUploadButtonRef.current?.click()}
        {...props}>
        <AttachFileIcon className={classes.icon} />
      </BaseActionButton>
      <input
        ref={fileUploadButtonRef}
        autoComplete="off"
        multiple
        style={{ display: 'none' }}
        tabIndex={-1}
        type="file"
        onChange={onFileInput}
      />
    </>
  );
};

export default AttachFilesActionButton;
